import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image37 from "../../../../assets/images/Blog41/image37 6months becomes 7 for SPX_.png";
import image35 from "../../../../assets/images/Blog41/image35 Nov seasonality1.png";
import image5 from "../../../../assets/images/Blog41/image5 ATH and record bad AD.png";
import image40 from "../../../../assets/images/Blog41/image40 repo stress1.png";
import image41 from "../../../../assets/images/Blog41/image41 repo stress2.png";
import image12 from "../../../../assets/images/Blog41/image12 Nexperia seizure.png";
import image45 from "../../../../assets/images/Blog41/image45 complacent options.png";
import image55 from "../../../../assets/images/Blog41/image55 SMH divergence from 200dma.png";
import image61 from "../../../../assets/images/Blog41/image61 gold consolidating first move down .png";
import image62 from "../../../../assets/images/Blog41/image62 copper supercycle confirmation_.png";
import image67 from "../../../../assets/images/Blog41/image67 whales feeding on 100+ wallets.png";
import image24 from "../../../../assets/images/Blog41/image24 NVDA bookings growing.png";
import image22 from "../../../../assets/images/Blog41/image22 strong Alphabet capex confidence for the cloud.png";
import image48 from "../../../../assets/images/Blog41/image48 EW NAS100 over-throw.png";

const Blog41 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – November 3rd, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText ">Melt-Up Momentum, Fed’s Pushback, and Breadth at Breaking Point</p>
        <p>
          Markets closed October with a powerful bid, fueled by structural earnings strength, a historic AI capex cycle, and a Trump–Xi trade pause that lowered geopolitical temperature. Yet beneath
          the surface, pressure points are quietly building. The melt-up narrative is gaining conviction, but the tape is narrow, liquidity is wobbling at the edges, and Powell just reminded traders
          that December is not a one-way bet.
        </p>
        <p>This is still a bull. But it’s a bull with a pulse — not a machine. And right now, that pulse is elevated.</p>

        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Melt-Up Meets Micro-Cracks</p>
              <p>
                Trump and Xi delivered a one-year trade truce — not a victory lap, but a confidence anchor. MAG5 earnings reinforced the AI capital cycle, with Amazon and Alphabet leading execution
                while Meta’s capex surge tested sentiment. Nvidia’s roadmap keeps pulling forward demand, and the market is finally acknowledging the public-private investment flywheel powering US
                tech leadership.
              </p>
              <p>
                The S&P 500 ended October <span className="highlightedText">+2.27%, its sixth straight monthly gain,</span> historically a precursor to further strength. November seasonality remains
                the strongest month on record.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image37}
                    alt=" 6months becomes 7 for SPX?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image37)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>

                <div className="relatedImg">
                  <img
                    src={image35}
                    alt="Nov seasonality1"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image35)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                However, leadership continues to shrink. The S&P printed an all-time high with <span className="highlightedText">80% of components closing red</span> — the most negative breadth ever
                recorded on an ATH day.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt="ATH and record bad AD"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                This is peak-thrust price action powered by the heaviest balance-sheet winners. It is not a sign to fade the market blindly — late-cycle rallies can run harder and longer than logic
                permits — but it does require discipline in entry timing and sector selection.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: The Fed Cut — With Conditions</p>
              <p>The Fed delivered the expected cut, but Powell applied the brakes on market exuberance, pushing December cut odds lower:</p>
              <p style={{fontStyle: "italic"}}>“December is not a given.”</p>
              <p>
                The message shook complacency. QT ends December 1st, shifting the liquidity map toward a quasi-QE regime as maturities are reinvested. Yet repo usage spiked to the highest level since
                2021 — a funding stress signal worth respecting as cash tightens under the surface.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image40}
                    alt="Nov seasonality1"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image40)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image41}
                    alt="repo stress2"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image41)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Geopolitically, the US-China truce stabilises short-term risk, but semiconductor protectionism and supply-chain sovereignty continue. Europe’s semiconductor seizure signals that this
                remains a global industrial arms race.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image12}
                    alt="Nexperia seizure"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image12)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Tariff litigation moves to the Supreme Court this week. If reciprocal tariffs are ruled illegal, cash refunds could generate a temporary liquidity pulse; if preserved, inflationary
                pressure persists into 2026. Markets are positioning for volatility, not policy whiplash.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Strength on Stilts</p>
              <p>
                Breadth deterioration is now structural, not situational. Semiconductors continue to lead, but the distance from long-run averages is widening. Extreme call activity, collapsing
                put-call ratios, and short-covering squeezes signal late-stage chase behaviour.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image55}
                    alt="SMH divergence from 200dma"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image55)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image45}
                    alt="complacent options"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image45)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The Nasdaq shows overthrow characteristics. This is constructive long-term but fragile short-term — the kind of structure where shallow dips matter and sloppy entries get punished.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image48}
                    alt="EW NAS100 over-throw"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image48)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Momentum remains bullish. Participation does not. The tape can still run, but investors must respect the dynamic: buy weakness, not strength; ride leaders, avoid laggards.</p>
              <p>
                Recent price action also reflects forced flows — particularly in mega-caps — while many mid-cap and cyclical pockets continue to lag. This is still a market where strong names grind
                higher, but weaker parts of the tape remain under pressure, reinforcing that rallies are being driven by capital concentration rather than broad risk appetite.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Earnings, Liquidity Signals, and Commodity Rotation</p>
              <p>
                Markets kicked off cautiously but rallied into Friday as Powell’s tone shifted from <span style={{fontStyle: "italic"}}> “cut path certainty” </span> to
                <span style={{fontStyle: "italic"}}> “data-dependent caution,” </span> while the Trump–Xi optics improved sentiment, and earnings reinforced the structural bull case. Liquidity
                questions surfaced via repo activity, but equity flows remained firm.
              </p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>Powell cooled expectations for a December cut, moving markets from ~95% certainty to a coin flip. QT ends December 1st, supporting
                    liquidity. Repo stress appeared, signalling funding pressure under the surface.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China: </span> A one-year trade truce eased geopolitical tension, but semiconductor policy remains confrontational. Supply-chain nationalism is
                    entrenched, not receding.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings: </span> Megacap tech confirmed another wave of AI spending into 2026+. Alphabet and Amazon executed strongly; Nvidia’s deal cadence
                    accelerated. Meta’s debt-funded capex put pressure on sentiment but affirmed competitive necessity.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image22}
                      alt="strong Alphabet capex confidence for the cloud"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image22)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                  <div className="relatedImg">
                    <img
                      src={image24}
                      alt="NVDA bookings growing"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image24)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities: </span>Copper confirmed super-cycle leadership on supply tightness and industrial capex. Gold broke $4k, tested lower, and stabilised
                    — still structurally bullish but vulnerable if USD firms.
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image62}
                    alt="copper supercycle confirmation?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image62)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image61}
                    alt="gold consolidating first move down"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image61)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span>No “Uptober” rally; crypto remains range-bound as policy delays weigh. Large wallet accumulation continues — long-term investors
                    are quietly positioning.
                  </p>
                </li>

                <div className="relatedImg">
                  <img
                    src={image67}
                    alt="whales feeding on 100+ wallets"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image67)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </ul>
              <p>The week reinforced a maturing melt-up dynamic: strength remains concentrated and liquidity-sensitive.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Central Banks, Shutdown Data Filters, and Earnings Rotation</p>
              <p>
                Four major central bank decisions and a broad earnings slate shape the week ahead. With the US government data limited, traders will lean on ISMs, PMIs, ADP, and Challenger job cuts to
                gauge labour elasticity and inflation stickiness.
              </p>
              <p className="highlightedText">Monday, Nov 3</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japan: </span> Culture Day (Holiday)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">France: </span>Industrial Production
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S. :</span> ISM Manufacturing, PMI, Bill Auctions
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings: </span>Berkshire Hathaway, Palantir, Hims & Hers
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, Nov 4</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>RBA Decision</p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">India: </span>Manufacturing PMI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S. : </span>JOLTS, Redbook, GDPNow
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings: </span>Uber, Shopify, Pfizer, AMD, BP, SuperMicro
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, Nov 5</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">India Holiday – </span> Guru Nanak Jayanti
                  </p>
                </li>
                <li className="themesPointer">
                  <p>Eurozone & UK PMIs</p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S. :</span> ADP, ISM Services
                  </p>
                </li>{" "}
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings: </span>Novo Nordisk, McDonald's, Qualcomm, ARM
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, Nov 6</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>BoE Decision</p>
                </li>
                <li className="themesPointer">
                  <p>Swiss Unemployment</p>
                </li>
                <li className="themesPointer">
                  <p>US Productivity & Unit Labour Costs</p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings: </span> Moderna, Airbnb, DraftKings, ConocoPhillips
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Friday, Nov 7</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>China Trade Balance</p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S. : </span>Michigan Sentiment & Inflation Expectations
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Canada: </span>Jobs
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings: </span>Duke Energy, Six Flags, Wendy’s
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image40}
                    alt="repo stress1"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image40)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image35}
                    alt="Nov seasonality1"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image35)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Melt-Up Still On — But Breathing Heavy</p>
              <p>
                The melt-up remains intact. Liquidity is shifting bullish, earnings leadership is real, and seasonal flows favour continuation. But breadth fractures, option skew, and funding stress
                argue for precision and patience.
              </p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br></br> Leadership is narrow but powerful. Buy controlled dips in dominant tech & infra names; avoid laggards below trend. Rotation risk rises if earnings disappoint in
                    second-tier names.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span> <br></br>Gold’s break and retest near $4,000 is pivotal. A hold maintains the structural bull; failure opens $3,800–3,550
                    risk. Watch real yields and the USD path into December.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span> <br></br> Positioning reset is broadly complete. Institutional accumulation continues. If liquidity stabilises post-QT shift,
                    crypto could break ranges in late November.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span> <br></br> The cut was expected; the conditional tone was not. The liquidity shift on December 1 is key — if funding stress abates,
                    upside resumes; if not, volatility returns quickly.
                  </p>
                </li>
              </ul>
              <p>
                {" "}
                The market remains bullish — but levered, narrow, and sensitive to liquidity tremors. Trade strength tactically, buy weakness methodically, and stay aware that this phase rewards
                discipline more than enthusiasm.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt=" ATH and record bad AD"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image61}
                    alt="gold consolidating first move down"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image61)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image67}
                    alt="whales feeding on 100+ wallets"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image67)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1ZrPCdyJ6Khzr9eAZ5fzfo_CWbuLQw08QlfkpDwRXT3g/edit?usp=sharing");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog41;
